import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import SelectSearch from '../selectinput/selectSearch/SelectSearch';
import CustomSelect from '../selectinput/CustomSelect/CustomSelect';
import SelectUserTrench from '../selectinput/SelectUserTrench';
import Input from '../input/Input';
import IconMinus from '../icon/IconMinus';
import IconPlus from '../icon/IconPlus';
import Button from '../Button/Button';
import ErrorWarnin from '../warningError/ErrorWarnin';
import CountDown from '../countdown/CountDown';
import RadioBox from '../radiobox/RadioBox';
import CheckBox from '../radiobox/CheckBox';
import IconDownload from '../icon/IconDownload';
import ModalCaptcha from '../captchaModal/ModalCaptcha';
import lang from '../../lang/lang.json';
import ModalSubmit from '../modalsubmit/ModalSubmit';
import Loader from '../../shared/components/Loader/Loader';
import './clientform.scss';

const ClientForm = () => {
    const {language} = useSelector((state) => state.language);

    const [userInn, setUserInn] = useState('');
    const [countDay, setCountDay] = useState(0);
    const [innData, setInnData] = useState([]);
    const [innTranch, setInnTranch] = useState([]);
    const [innReasons, setInnReasons] = useState([]);
    const [innPhone, setInnPhone] = useState('');
    const [openCounter, setOpenCounter] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [isCheckedMonth, setIsCheckedMonth] = useState(null);
    const [isCaptcha, setIsCaptcha] = useState(false);
    const [captchaInput, setCaptchaInput] = useState('');
    const [captchaImg, setCaptchaImg] = useState('');
    const [captchaType, setCaptchaType] = useState('');
    const [selectedTransh, setSelectedTranshTransh] = useState([]);
    const [selectedReason, setSelectedReason] = useState([]);
    const [selected, setSelected] = useState('');
    const [getSmsCode, setGetSmsCode] = useState('');
    const [cityId, setCityId] = useState(null);
    const [isValid, setIsValid] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isCodeError, setIsCodeError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [isSubmit, setIsSubmit] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isEmpty, setIsEmpty] = useState(false);
    const [isSubmitError, setIsSubmitError] = useState(false);
    const [submitErrorMessage, setSubmitErrorMessage] = useState('');

    let activeTranches = selectedTransh.map((el) => el.number).join(',');
    let activeReasons = selectedReason.map((el) => el.id).join(',');

    useEffect(() => {
        activeTranches = selectedTransh.map((el) => el.number).join(',');
        activeReasons = selectedReason.map((el) => el.id).join(',');
    }, [selectedTransh, activeReasons]);

    const handleCaptchaInput = (event) => {
        setCaptchaInput(event.target.value);
    };

    const handleCorrectInn = (e) => {
        setUserInn(e.target.value);
        if (e.target.value.length === 9 && e.target.value.length < 1) {
            setIsError(false);
        }
    };

    const handleUserInn = (event) => {
        if (event.target.value.length !== 9) {
            setIsError(true);
            setInnTranch([]);
            setInnData([]);
            setInnReasons([]);
            setInnPhone('');
            setIsEmpty(false);
            setIsSubmitError(false);
        }
        if (event.target.value.length === 0) {
            setIsError(false);
        }
    };
    const handleChangeSms = (event) => {
        setGetSmsCode(event.target.value);
        if (event.target.value.length === 4) {
            setIsCodeError(false);
        } else {
            setIsCodeError(true);
        }
    };

    function incrementDay() {
        setCountDay(function (prevCount) {
            if (prevCount < 14) {
                return (prevCount += 1);
            }
            return (prevCount = 14);
        });
    }

    function decrementDay() {
        setCountDay(function (prevCount) {
            if (prevCount > 0) {
                return (prevCount -= 1);
            } else {
                return (prevCount = 0);
            }
        });
    }

    useEffect(() => {
        if (userInn.length !== 9) return;
        const handleGetUserTranch = async () => {
            const res = await fetch(
                `https://muhlat.alif.tj/api/covidalif/v0/public/info`,
                {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                    }),
                    body: JSON.stringify({
                        lang: language,
                        itn: userInn,
                        captcha: captchaInput,
                    }),
                }
            );

            switch (res.status) {
                case 200:
                    setOpenCounter(false);
                    setGetSmsCode('');
                    const jsonData = await res.json();
                    setInnData(jsonData.payload.cities);
                    if (!jsonData.payload?.credits) {
                        setIsEmpty(true);
                    } else {
                        setIsEmpty(false);
                        setInnTranch(jsonData?.payload?.credits);
                    }
                    setInnReasons(jsonData.payload.reasons);
                    setInnPhone(jsonData.payload.phone);
                    setIsCaptcha(false);
                    setSuccessMessage(jsonData.message);
                    setIsError(false);
                    setIsSuccess(true);
                    break;
                case 400:
                    setOpenCounter(false);
                    setGetSmsCode('');
                    setInnTranch([]);
                    setInnData([]);
                    setInnReasons([]);
                    setInnPhone('');
                    setIsCaptcha(false);
                    setIsSuccess(false);
                    break;
                case 429:
                    setOpenCounter(false);
                    setGetSmsCode('');
                    setInnTranch([]);
                    setInnData([]);
                    setInnReasons([]);
                    setInnPhone('');
                    setCaptchaType('inn');
                    const blob = await res.blob();
                    setIsCaptcha(true);
                    const image = URL.createObjectURL(blob);
                    setCaptchaImg(image);
                    setIsSuccess(false);
                    break;
                case 500:
                    setOpenCounter(false);
                    setGetSmsCode('');
                    const jsonMessage = await res.json();
                    setInnTranch([]);
                    setInnData([]);
                    setInnReasons([]);
                    setInnPhone('');
                    setIsError(true);
                    setErrorMessage(jsonMessage.message);
                    setIsCaptcha(false);
                    setIsSuccess(false);
                    break;
                default:
                    break;
            }
        };

        handleGetUserTranch();
    }, [userInn]);

    const handleGetSms = async () => {
        const res = await fetch(
            `https://muhlat.alif.tj/api/covidalif/v0/public/otp`,
            {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                }),
                body: JSON.stringify({
                    lang: language,
                    itn: userInn,
                    captcha: captchaInput,
                }),
            }
        );

        switch (res.status) {
            case 200:
                setSubmitErrorMessage('');
                setIsCaptcha(false);
                setOpenCounter(true);
                break;
            case 400:
                setIsCaptcha(false);
                break;
            case 429:
                setCaptchaType('sms');
                const blob = await res.blob();
                setIsCaptcha(true);
                const image = URL.createObjectURL(blob);
                setCaptchaImg(image);
                break;
            case 500:
                setIsCaptcha(false);
                break;
            default:
                break;
        }
    };

    // const handleDownloadFile = async () => {
    //     const res = await fetch(
    //         `https://muhlat.alif.tj/api/covidalif/v0/public/file`,
    //         {
    //             method: 'POST',
    //             headers: new Headers({
    //                 'Content-Type': 'application/json',
    //             }),
    //             body: JSON.stringify({
    //                 lang: language,
    //                 itn: userInn,
    //                 trench: activeTranches,
    //                 period: countDay,
    //                 captcha: captchaInput,
    //             }),
    //         }
    //     );
    //
    //     switch (res.status) {
    //         case 200:
    //             const blobPDF = await res.blob();
    //             var url = window.URL.createObjectURL(blobPDF);
    //             var a = document.createElement('a');
    //             a.href = url;
    //             a.download = 'Документ.pdf';
    //             document.body.appendChild(a);
    //             a.click();
    //             a.remove();
    //             break;
    //         case 400:
    //             setIsCaptcha(false);
    //             break;
    //         case 429:
    //             setCaptchaType('file');
    //             const blob = await res.blob();
    //             setIsCaptcha(true);
    //             const image = URL.createObjectURL(blob);
    //             setCaptchaImg(image);
    //             break;
    //         case 500:
    //             setIsCaptcha(false);
    //             break;
    //         default:
    //             break;
    //     }
    // };

    const handleCloseCaptcha = () => {
        setIsCaptcha(false);
    };

    const checkCaptchaType = async () => {
        setIsCaptcha(false);
        if (captchaType === 'inn') {
            const res = await fetch(
                `https://muhlat.alif.tj/api/covidalif/v0/public/info`,

                {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                    }),
                    body: JSON.stringify({
                        lang: language,
                        itn: userInn,
                        captcha: captchaInput,
                    }),
                }
            );

            switch (res.status) {
                case 200:
                    const jsonData = await res.json();
                    setInnData(jsonData.payload.cities);
                    if (jsonData.payload.credits) {
                        setIsEmpty(true);
                    } else {
                        setIsEmpty(false);
                        setInnTranch(jsonData.payload.credits);
                    }
                    setInnReasons(jsonData.payload.reasons);
                    setInnPhone(jsonData.payload.phone);
                    setIsCaptcha(false);
                    setIsError(false);
                    setIsSuccess(true);

                    break;
                case 400:
                    setIsCaptcha(true);
                    setInnTranch([]);
                    setInnData([]);
                    setInnReasons([]);
                    setInnPhone('');
                    setIsCaptcha(false);
                    break;
                case 429:
                    const blob = await res.blob();
                    setIsCaptcha(true);
                    const image = URL.createObjectURL(blob);
                    setCaptchaImg(image);
                    setInnTranch([]);
                    setInnData([]);
                    setInnReasons([]);
                    setInnPhone('');
                    break;
                case 500:
                    setIsCaptcha(true);
                    const jsonMessage = await res.json();
                    setInnTranch([]);
                    setInnData([]);
                    setInnReasons([]);
                    setErrorMessage(jsonMessage.message);
                    setInnPhone('');
                    setIsError(true);
                    setIsCaptcha(false);
                    break;
                default:
                    break;
            }
        } else if (captchaType === 'sms') {
            const res = await fetch(
                `https://muhlat.alif.tj/api/covidalif/v0/public/otp`,
                {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                    }),
                    body: JSON.stringify({
                        lang: language,
                        itn: userInn,
                        captcha: captchaInput,
                    }),
                }
            );

            switch (res.status) {
                case 200:
                    setSubmitErrorMessage('');
                    setIsCaptcha(false);
                    setOpenCounter(true);
                    break;
                case 400:
                    setIsCaptcha(false);
                    break;
                case 429:
                    const blob = await res.blob();
                    setIsCaptcha(true);
                    const image = URL.createObjectURL(blob);
                    setCaptchaImg(image);
                    break;
                case 500:
                    const jsonData = await res.json();
                    setIsSubmitError(true);
                    setSubmitErrorMessage(jsonData.message);
                    setIsCaptcha(false);
                    break;
                default:
                    break;
            }
        } else if (captchaType === 'file') {
            const res = await fetch(
                `https://muhlat.alif.tj/api/covidalif/v0/public/file`,

                {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                    }),
                    body: JSON.stringify({
                        itn: userInn,
                        trench: activeTranches,
                        period: countDay,
                        lang: language,
                        captcha: captchaInput,
                    }),
                }
            );

            switch (res.status) {
                case 200:
                    setIsCaptcha(false);
                    const blobPDF = await res.blob();
                    var url = window.URL.createObjectURL(blobPDF);
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = 'Документ.pdf';
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    break;
                case 400:
                    setIsCaptcha(false);
                    break;
                case 429:
                    setCaptchaType('file');
                    const blob = await res.blob();
                    setIsCaptcha(true);
                    const image = URL.createObjectURL(blob);
                    setCaptchaImg(image);
                    break;
                case 500:
                    setIsCaptcha(false);
                    break;
                default:
                    break;
            }
        } else if (captchaType === 'form') {
            setIsLoading(true);
            const res = await fetch(
                `https://muhlat.alif.tj/api/covidalif/v0/public/application/add`,
                {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                    }),
                    body: JSON.stringify({
                        itn: userInn,
                        trench: activeTranches,
                        reason: activeReasons,
                        captcha: captchaInput,
                        lang: language,
                        period: countDay,
                        city_id: cityId,
                        code: getSmsCode,
                        all_payments: isCheckedMonth === 'true' ? true : false,
                    }),
                }
            );
            switch (res.status) {
                case 200:
                    const jsonInfo = await res.json();
                    let blobPDF = jsonInfo.info;
                    const response = await fetch(blobPDF, {
                        method: 'GET',
                        headers: new Headers({
                            'Content-Type': 'application/json',
                        }),
                    });
                    switch (response.status) {
                        case 200:
                            const blobPDF = await response.blob();
                            var url = window.URL.createObjectURL(blobPDF);
                            var a = document.createElement('a');
                            a.href = url;
                            a.download = 'Документ.pdf';
                            document.body.appendChild(a);
                            a.click();
                            a.remove();
                            break;
                        default:
                            break;
                    }
                    setIsLoading(false);
                    setIsSubmit(true);
                    setIsCaptcha(false);
                    setUserInn('');
                    setSelected('');
                    setGetSmsCode('');
                    setCityId(null);
                    setInnTranch([]);
                    setInnData([]);
                    setInnReasons([]);
                    setInnPhone('');
                    break;
                case 400:
                    const json = await res.json();
                    setIsSubmitError(true);
                    setSubmitErrorMessage(json.message);
                    setIsLoading(false);
                    setIsCaptcha(false);
                    break;
                case 429:
                    setIsLoading(false);
                    setCaptchaType('form');
                    const blob = await res.blob();
                    setIsCaptcha(true);
                    const image = URL.createObjectURL(blob);
                    setCaptchaImg(image);
                    break;
                case 500:
                    const jsonData = await res.json();
                    setIsSubmitError(true);
                    setSubmitErrorMessage(jsonData.message);
                    setIsLoading(false);
                    setIsCaptcha(false);
                    break;
                default:
                    break;
            }
        }
    };

    useEffect(() => {
        if (
            userInn.length === 9 &&
            cityId !== null &&
            activeTranches.length !== 0 &&
            activeReasons.length !== 0 &&
            countDay !== 0 &&
            getSmsCode.length === 4 &&
            Boolean(isCheckedMonth) !== null &&
            isChecked === true
        ) {
            setIsValid(true);
        } else {
            setIsValid(false);
        }
    }, [
        isValid,
        userInn,
        cityId,
        activeTranches,
        activeReasons,
        countDay,
        getSmsCode,
        isCheckedMonth,
        isChecked,
    ]);

    useEffect(() => {
        if (userInn.length <= 5) {
            setInnTranch([]);
            setInnData([]);
            setInnReasons([]);
            setInnPhone('');
        }
    }, [userInn]);

    const handleSubmitForm = async () => {
        setIsLoading(true);
        const res = await fetch(
            `https://muhlat.alif.tj/api/covidalif/v0/public/application/add`,
            {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                }),
                body: JSON.stringify({
                    itn: userInn,
                    trench: activeTranches,
                    reason: activeReasons,
                    captcha: captchaInput,
                    lang: language,
                    period: countDay,
                    city_id: cityId,
                    code: getSmsCode,
                    all_payments: isCheckedMonth === 'true' ? true : false,
                }),
            }
        );

        switch (res.status) {
            case 200:
                setOpenCounter(false);
                setGetSmsCode('');
                const jsonInfo = await res.json();
                let blobPDF = jsonInfo.info;
                const response = await fetch(blobPDF, {
                    method: 'GET',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                    }),
                });
                switch (response.status) {
                    case 200:
                        const blobPDF = await response.blob();
                        var url = window.URL.createObjectURL(blobPDF);
                        var a = document.createElement('a');
                        a.href = url;
                        a.download = 'Документ.pdf';
                        document.body.appendChild(a);
                        a.click();
                        a.remove();
                        setTimeout(() => {
                            window.location.reload();
                        }, 10000);
                        break;
                    default:
                        break;
                }
                setIsLoading(false);
                setIsSubmit(true);
                setIsCaptcha(false);
                setUserInn('');
                setSelected('');
                setGetSmsCode('');
                setCityId(null);
                setInnTranch([]);
                setInnData([]);
                setInnReasons([]);
                setInnPhone('');
                break;
            case 400:
                const json = await res.json();
                setIsSubmitError(true);
                setSubmitErrorMessage(json.message);
                setIsLoading(false);
                setIsCaptcha(false);
                break;
            case 429:
                setIsLoading(false);
                setCaptchaType('form');
                const blob = await res.blob();
                setIsCaptcha(true);
                const image = URL.createObjectURL(blob);
                setCaptchaImg(image);
                break;
            case 500:
                const jsonData = await res.json();
                setIsSubmitError(true);
                setSubmitErrorMessage(jsonData.message);
                setIsLoading(false);
                setIsCaptcha(false);
                break;
            default:
                break;
        }
    };

    return (
        <div id="form" className="clentform-container-background">
            <div className=" p-50 clentform-container-outer ">
                {isCaptcha && (
                    <ModalCaptcha
                        img={captchaImg}
                        handleCloseCaptcha={handleCloseCaptcha}
                        handleCaptchaInput={handleCaptchaInput}
                        captchaInput={captchaInput}
                        setCaptchaInput={setCaptchaInput}
                        onCaptchaSend={() => checkCaptchaType()}
                    />
                )}
                {isSubmit && (
                    <ModalSubmit
                        isSubmit={isSubmit}
                        setIsSubmit={setIsSubmit}
                        id="submit-modal"
                    />
                )}
                {isLoading && <Loader/>}
                <div className="clentform-container">
                    <div className="clentform-selects-div">
                        <div className="clentform-title">
                            <h2>{lang.CLIENT_FORM_TITLE[language]} </h2>
                        </div>
                        <Input
                            label={lang.INPUT_INN_LABEL[language]}
                            placeholder={lang.INPUT_INN_PLACEHOLDER[language]}
                            onChange={handleCorrectInn}
                            error={isError ? 'inputError' : ''}
                            onBlur={handleUserInn}
                            value={userInn}
                            type="number"
                        />
                        <div className="errorMessage">
                            {/* <p>
              {isEmpty && innTranch.length === 0 && "Отсутствуют кредиты"}

              </p> */}
                            <p>
                                {isEmpty ? lang.NOT_FOUND_CREDIT[language] : ''}

                            </p>
                        </div>
                        <span className="successMessage">
              {userInn.length > 8 && !isEmpty && !isError && isSuccess
                  ? lang.SUBMIT_SUCCESS_TEXT[language]
                  : ''}
            </span>
                        {isError && (
                            <span className="errorMessage">
                {userInn.length !== 9
                    ? lang.INPUT_ERROR_TEXT[language]
                    : errorMessage}
              </span>
                        )}
                        <SelectSearch
                            id="selectSearch"
                            name="selectSearch"
                            label={lang.INPUT_CITY_LABEL[language]}
                            placeholder={lang.INPUT_CITY_PLACEHOLDER[language]}
                            selectData={innData}
                            selected={selected}
                            setSelected={setSelected}
                            cityId={cityId}
                            setCityId={setCityId}
                            pointerEvent={innTranch !== 0 ? false : true}
                        />
                        <SelectUserTrench
                            id="selectTrench"
                            name="selectTrench"
                            label={lang.INPUT_TRENCH_LABEL[language]}
                            onChangeSelectData={(newData) => setInnTranch(newData)}
                            placeholder={lang.INPUT_TRENCH_PLACEHOLDER[language]}
                            selectData={innTranch}
                            selectedTransh={selectedTransh}
                            setSelectedTranshTransh={setSelectedTranshTransh}
                            pointerEvent={innTranch !== 0 ? false : true}
                        />
                        <div>
                            <div className="checkbox-pay-title">
                                {lang.MAKE_MONTH_TO_TAKE_LONG[language]}
                            </div>
                            <div className="checkbox-pay-div">
                                <div className="checkbox-pay">
                                    <RadioBox
                                        name={'paymentMethod'}
                                        value={false}
                                        isChecked={isCheckedMonth === 'false'}
                                        onChange={(e) => {
                                            setIsCheckedMonth(e.target.value);
                                        }}
                                    />
                                    {lang.MONTH_TO_TAKE[language]}
                                </div>
                                <div className="checkbox-pay">
                                    <RadioBox
                                        name={'paymentMethod'}
                                        value={true}
                                        isChecked={isCheckedMonth === 'true'}
                                        onChange={(e) => {
                                            setIsCheckedMonth(e.target.value);
                                        }}
                                    />
                                    {lang.MONTH_TO_TAKE_ALL[language]}
                                </div>
                            </div>
                        </div>
                        <div
                            className={`client-gettime-div ${
                                innTranch === 0 ? 'disabled_select' : ''
                            }`}
                        >
                            <div>{lang.DAY_TO_TAKE_TEXT[language]}</div>
                            <div className="client-gettime-inc-dec">
                                <button className="button-inc-dec" onClick={decrementDay}>
                                    <IconMinus/>
                                </button>
                                {countDay} {lang.DAY_TO_TAKE_DAY[language]}
                                <button className="button-inc-dec" onClick={incrementDay}>
                                    <IconPlus/>
                                </button>
                            </div>
                        </div>
                        <CustomSelect
                            id="selectReason"
                            name="selectReason"
                            label={lang.INPUT_REASON_LABEL[language]}
                            placeholder={lang.INPUT_REASON_PLACEHOLDER[language]}
                            onChangeSelectData={(newData) => setInnReasons(newData)}
                            selectData={innReasons}
                            selectedReason={selectedReason}
                            setSelectedReason={setSelectedReason}
                            pointerEvent={innTranch?.length !== 0 ? false : true}
                        />
                        {!openCounter && (
                            <div className="client-tel-div ">
                                {lang.PHONE_SMS_TEXT_1[language]} <br/>
                                {lang.PHONE_SMS_TEXT_2[language]} {innPhone} <br/>
                                <div className="phone-button-div" onClick={handleGetSms}>
                                    {lang.PHONE_SMS_BUTTON[language]}
                                </div>
                            </div>
                        )}
                        {openCounter && (
                            <div>
                                {lang.PHONE_SMS_LABEL_LABEL[language]} +992 {innPhone}
                            </div>
                        )}
                        {openCounter && (
                            <Input
                                label={lang.PHONE_SMS_INPUT_LABEL[language]}
                                placeholder={lang.PHONE_SMS_INPUT_INPUT[language]}
                                onChange={(e) => handleChangeSms(e)}
                                error={isCodeError ? 'inputError' : ''}
                                value={getSmsCode}
                            />
                        )}
                        <span className="errorMessage">
              {isSubmitError && !isCodeError && openCounter
                  ? submitErrorMessage
                  : ''}
            </span>
                        {isCodeError && openCounter && (
                            <span className="errorMessage">
                {lang.PHONE_SMS_INPUT_ERROR[language]}
              </span>
                        )}
                        {openCounter && (
                            <CountDown
                                handleOpen={handleGetSms}
                                handleGetSms={handleGetSms}
                            />
                        )}
                        {openCounter && <ErrorWarnin/>}
                        <div className="checkbox-privacy-div">
                            <CheckBox isChecked={isChecked} setIsChecked={setIsChecked}/>

                            {lang === '' ? <div className="checkbox-text">
                                {lang.USER_AGREEMENT_1[language]}{" "}
                                <a
                                    href="/Оферта.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <span>{lang.USER_AGREEMENT_2[language]}</span>
                                </a>{" "}
                                {lang.USER_AGREEMENT_3[language]}
                                <a
                                    href='https://alifwebsite.alif.tj/uploads/Soglashenie_dlya_obrabotki_dannyh_84dbe0bc16.pdf'
                                    target='_blank'
                                >
                <span>
                  {lang.USER_AGREEMENT_4[language]}
                </span>
                                </a>
                            </div> : <div className="checkbox-text">
                                {lang.USER_AGREEMENT_1[language]}{" "}
                                <a
                                    href="/Оферта.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <span>{lang.USER_AGREEMENT_2[language]}</span>
                                </a>{" "}
                                {lang.USER_AGREEMENT_3[language]}
                                <a
                                    href='https://alifwebsite.alif.tj/uploads/Soglashenie_dlya_obrabotki_dannyh_84dbe0bc16.pdf'
                                    target='_blank'
                                >
                <span>
                  {lang.USER_AGREEMENT_4[language]}
                </span>
                                </a>
                  {lang.USER_AGREEMENT_5[language]}
                            </div>}
                        </div>

                        <div className="client-submit-div">
                            <Button
                                onClick={handleSubmitForm}
                                text={lang.SUBMIT_FORM_BUTTON[language]}
                                variant={isValid ? 'primary' : 'disable'}
                                textStyle="normal"
                                disabled={!isValid}
                            />
                            {/*<Button*/}
                            {/*    onClick={handleDownloadFile}*/}
                            {/*    text={lang.DOWNLOAD_FORM_BUTTON[language]}*/}
                            {/*    variant={isValid ? "light" : "disable"}*/}
                            {/*    textStyle="download"*/}
                            {/*    icon={<IconDownload/>}*/}
                            {/*    disabled={!isValid}*/}
                            {/*/>*/}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default ClientForm;
